/** URL del servidor (Fastify + Socket.IO). En Cloudflare Pages se define en el build. */
export const SERVER_URL: string = (import.meta.env.VITE_SERVER_URL as string | undefined) ?? 'http://localhost:8080';
